import { useState, useEffect } from "react";
import { LinearProgress } from "@mui/material";
import { KODE_STATUS_TYPE } from "../../../../utils/constants/StatusType.constants";
import PeerReviewService from "../../../../services/Integration/peer-review/PeerReviewService";
import MKSpesialService from "../../../../services/Integration/mkspesial/MKSpesialService";
import ProfileService from "../../../../services/Integration/profile/ProfileService";

const { default: Auth } = require("@services/Auth/Auth");

export default function PeerReview({ kelompok, mkSpesialId, isLoading0 }) {
  const [isLoading, setIsLoading] = useState(isLoading0);
  const [isDisabled, setIsDisabled] = useState(true);
  const [peerReviews, setPeerReviews] = useState({});
  const [isChanged, setIsChanged] = useState({});
  const [kelompokTanpaDiri, setKelompokTanpaDiri] = useState([]);

  const refreshData = async () => {
    setIsLoading(true);
    await getStatusMKSpesial();
    await getPeerReview();
    setIsLoading(false);
  };

  useEffect(async () => {
    setIsLoading(true);
    await getMahasiswaData();
    await getStatusMKSpesial();
    setIsLoading(false);
  }, []);

  const getMahasiswaData = async () => {
    await ProfileService.getMahasiswaInfo().then(async (response) => {
      if (response.status === 200) {
        await filterKelompok(response.data.id_mahasiswa);
      } else {
        console.log("Error fetching student info.");
      }
    });
  };

  const filterKelompok = async (mahasiswaId) => {
    const tableData = {};
    const isChanged0 = {};
    const currentUserId = mahasiswaId || Auth.getCurrentUser().id;
    const kelompokTanpaDiriTemp = [];
    for (let i = 0; i < kelompok.length; i++) {
      if (currentUserId !== kelompok[i].id_mahasiswa) {
        const emptyRow = {
          penilai: currentUserId,
          id_mahasiswa: kelompok[i].id_mahasiswa,
          dinilai: kelompok[i].id_mahasiswa,
          nama_mahasiswa: kelompok[i].nama_mahasiswa,
          nilai: 0,
          deskripsi: "",
          mk_spesial: mkSpesialId,
          graded: false,
        };
        tableData[kelompok[i].id_mahasiswa] = emptyRow;
        isChanged0[kelompok[i].id_mahasiswa] = false;
        kelompokTanpaDiriTemp.push(emptyRow);
      }
    }

    setIsChanged(isChanged0);
    setKelompokTanpaDiri(kelompokTanpaDiriTemp);
    await getPeerReview(tableData, kelompokTanpaDiriTemp);
  }

  function checkEditablePeerReview(kode) {
    if (
      kode === KODE_STATUS_TYPE.KODE_ETIK_DAN_ATAU_BERKAS_BELUM_DIISI ||
      kode === KODE_STATUS_TYPE.MAJU_SIDANG_BELUM_DISETUJUI ||
      kode === KODE_STATUS_TYPE.JADWAL_SIDANG_BELUM_DITENTUKAN ||
      kode === KODE_STATUS_TYPE.MENUNGGU_PEER_REVIEW ||
      kode === KODE_STATUS_TYPE.MENUNGGU_SIDANG
    ) {
      setIsDisabled(false);
    }
  }
  const getStatusMKSpesial = async () => {
    await MKSpesialService.getStatusMKSpesial(mkSpesialId)
      .then((response) => {
        if (response.status === 200) {
          checkEditablePeerReview(response.data.kode);
        }
      })
      .catch((response) => console.log(response));
  };

  const getPeerReview = async (tableData = peerReviews, kelompokTanpaDiriTemp = kelompokTanpaDiri) => {
    await PeerReviewService.getPeerReview(mkSpesialId)
      .then((response) => {
        if (response.status === 200) {
          const data = response.data;
          let peerReviewsCopy = JSON.parse(JSON.stringify(tableData));

          for (let i = 0; i < kelompokTanpaDiriTemp.length; i++) {
            const id_mahasiswa = kelompokTanpaDiriTemp[i].id_mahasiswa;
            for (let j = 0; j < data.length; j++) {
              if (
                (id_mahasiswa === data[j].dinilai) &
                (tableData[id_mahasiswa].penilai === data[j].penilai)
              ) {
                peerReviewsCopy[id_mahasiswa].nilai = data[j].nilai;
                peerReviewsCopy[id_mahasiswa].deskripsi = data[j].deskripsi;
                peerReviewsCopy[id_mahasiswa]["id"] = data[j].id;
                peerReviewsCopy[id_mahasiswa].graded = true;
              }
            }
          }
          setPeerReviews(peerReviewsCopy);
        }
      })
      .catch((response) => console.log(response));
  };

  const handlePostPeerReview = async (postData) => {
    setIsLoading(true);
    delete postData.graded;
    delete postData.id_mahasiswa;
    delete postData.nama_mahasiswa;
    await PeerReviewService.postPeerReview(postData)
      .then((response) => {
        if (response.status === 201) refreshData();
      })
      .catch((response) => console.log(response));
    setIsLoading(false);
  };

  const handleUpdatePeerReview = async (data) => {
    setIsLoading(true);
    delete data.graded;
    delete data.id_mahasiswa;
    delete data.nama_mahasiswa;
    await PeerReviewService.updatePeerReview(data)
      .then((response) => {
        if (response.status === 200) refreshData();
      })
      .catch((response) => console.log(response));
    setIsLoading(false);
  };

  const handleOnChangeNilai = (nilaiBaru, mahasiswa) => {
    if (nilaiBaru > 100) {
      nilaiBaru = 100;
    } else if (nilaiBaru < 0) {
      nilaiBaru = 0;
    }
    let temp = { ...peerReviews };
    temp[mahasiswa.id_mahasiswa]["nilai"] = nilaiBaru;
    let temp2 = { ...isChanged };
    temp2[mahasiswa.id_mahasiswa] = true;
    setPeerReviews(temp);
    setIsChanged(temp2);
  };

  const handleOnChangeCatatan = (catatanBaru, mahasiswa) => {
    let temp = { ...peerReviews };
    temp[mahasiswa.id_mahasiswa]["deskripsi"] = catatanBaru;
    let temp2 = { ...isChanged };
    temp2[mahasiswa.id_mahasiswa] = true;
    setPeerReviews(temp);
    setIsChanged(temp2);
  };

  const handleOnClickSubmit = () => {
    for (let i = 0; i < kelompokTanpaDiri.length; i++) {
      const id_mahasiswa = kelompokTanpaDiri[i].id_mahasiswa;
      if (peerReviews[id_mahasiswa].graded) {
        if (isChanged[id_mahasiswa]) {
          handleUpdatePeerReview(peerReviews[id_mahasiswa]);
        }
      } else {
        peerReviews[id_mahasiswa].graded = true;
        handlePostPeerReview(peerReviews[id_mahasiswa]);
      }
    }
  };

  return (
    <div className="mt-4 my-8">
      <div className="border border-slate-300 rounded-md place-content-end">
        <div className="p-4 bg-slate-300">Peer Review</div>
        {isLoading ? (
          <LinearProgress />
        ) : (
          <div>
            <div className="p-4 flex flex-col gap-3">
              <div className="flex flex-row font-bold">
                <div className="basis-1/3">Nama Mahasiswa</div>
                <div className="basis-2/3 flex flex-row gap-1">
                  <div className="basis-1/4 md:basis-1/5">
                    Nilai (0-100)
                    <span className="font-bold text-red-500">*</span>
                  </div>
                  <div className="basis-3/4 md:basis-4/5">Catatan</div>
                </div>
              </div>
              {kelompokTanpaDiri.map((mahasiswa, index) => {
                return (
                  <div className="flex flex-row" key={index}>
                    <div className="basis-1/3">{mahasiswa.nama_mahasiswa}</div>
                    <div className="basis-2/3 flex flex-row gap-1">
                      <div className="basis-1/4 md:basis-1/5">
                        <input
                          disabled={isDisabled}
                          type={"number"}
                          className="px-2 w-20 rounded-md border border-slate-300 focus:border-blue-300 hover:border-black text-center"
                          max={100}
                          min={0}
                          onChange={(event) =>
                            handleOnChangeNilai(event.target.value, mahasiswa)
                          }
                          value={
                            peerReviews[mahasiswa.id_mahasiswa]["nilai"] === 0
                              ? "00.00"
                              : peerReviews[mahasiswa.id_mahasiswa]["nilai"]
                          }
                        />
                      </div>
                      <div className="basis-3/4 md:basis-4/5">
                        <textarea
                          disabled={isDisabled}
                          className="shadow appearance-none border h-14 /
                                  rounded w-full py-2 px-3 text-gray-700 /
                                  leading-tight focus:outline-none /
                                  focus:shadow-outline mb-3 w-full"
                          onChange={(event) =>
                            handleOnChangeCatatan(event.target.value, mahasiswa)
                          }
                          placeholder="..."
                          value={peerReviews[mahasiswa.id_mahasiswa]["deskripsi"]}
                        />
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="flex flex-row">
              <div className="flex-1"> </div>
              <button
                type="button"
                className="bg-green-500 hover:bg-green-700 \
                    text-white font-bold py-2 px-4 rounded-full \
                    place-content-end mb-4"
                onClick={() => handleOnClickSubmit()}
              >
                Simpan
              </button>
              <div className="flex-1"> </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
